import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#436148",
                myGreen: "#688a6c",
                myGreen2: "#bdd1a2",
                myGreen3: "#286a60",
                myWhite: "#fafafa",
                myBlue: "#1f5562",
                myBlue2: "#32798f",
                myOrange: "#a54e3b",
                myBrown: "#a4705a",
                myYellow1: "#f0ab31",
                myYellow2: "#fde285",
                myYellow3:"#fac849",
                myRed:"#b02323",
            },
        },
    },
});
